import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { GenericPut } from '@/_shared/types';
import { API_ORGANIZATIONS_ORGANIZATIONID_USERS_ACTIVE_CONTEXT_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_PUT_ACTIVATE_CONTEXT, KEY_PUT_ACTIVATE_CONTEXT } from '../constants';
import { getCurrentOrganization } from '../selectors';

type RequestActivateContext = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USERS_ACTIVE_CONTEXT_PATH_KEY
>['request']['body'];

export type CallParamsPutActivateContext = RequestActivateContext & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePutActivateContext = unknown;

type CallErrorPutActivateContext = {
  message: string;
  code: number;
};

type CallSelectorsPutActivateContext = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const putActivateContextCall = createGeneralCall<
  CallParamsPutActivateContext,
  CallResponsePutActivateContext,
  CallErrorPutActivateContext,
  CallSelectorsPutActivateContext
>({
  id: KEY_PUT_ACTIVATE_CONTEXT,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_PUT_ACTIVATE_CONTEXT(org as unknown as string);
  },
  method: 'put',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  responseMapper,
});
